import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface FilterState {
  [chartId: string]: {
    dateRange: [string | null, string | null] | null;
    department: string;
    employmentStatus: string;
    employmentType: string;
    gender: string;
  };
}

const initialState: FilterState = {};

const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setFilter(
      state,
      action: PayloadAction<{
        chartId: string;
        filter: Partial<FilterState[string]>;
      }>,
    ) {
      const { chartId, filter } = action.payload;
      state[chartId] = { ...state[chartId], ...filter };
    },
  },
});

export const { setFilter } = filterSlice.actions;
export default filterSlice.reducer;
